// removed by extract-text-webpack-plugin
module.exports = {"text":"src-components----_Egg-module---text---1ybt9","stroke":"src-components----_Egg-module---stroke---1I29J"};


//////////////////
// WEBPACK FOOTER
// ./src/components/_Egg.module.scss
// module id = 250
// module chunks = 35783957827783